const API_BASE_URL = process.env.REACT_APP_API_URL ;
const STORAGE_KEY = 'dynamic_forms_auth';

export function fileUrl(relativePath) {
  return `${API_BASE_URL}${relativePath}`;
}

export function getStoredUser() {
  const raw = localStorage.getItem(STORAGE_KEY);
  return raw ? JSON.parse(raw) : null;
}

export function storeUser(user) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(user));
}

export function clearStoredUser() {
  localStorage.removeItem(STORAGE_KEY);
}

export async function apiRequest(path, options = {}) {
  const user = getStoredUser();
  const isFormData = options.body instanceof FormData;
  const headers = {
    ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
    ...(user?.token ? { Authorization: `Bearer ${user.token}` } : {}),
    ...options.headers,
  };

  const response = await fetch(`${API_BASE_URL}${path}`, { ...options, headers });
  if (response.status === 401 && user?.token) {
    // Token süresi dolmuş/geçersiz — oturumu temizle ve login'e yönlendirmesi için olay yayınla
    clearStoredUser();
    window.dispatchEvent(new Event('auth:unauthorized'));
  }
  if (response.status === 204) {
    return null;
  }

  const text = await response.text();
  const data = text ? JSON.parse(text) : null;
  if (!response.ok) {
    // HTTP status kodu hata nesnesine eklenir — çağıranlar 404/409 vb. ayırt edebilir
    const err = new Error(data?.message || 'İstek tamamlanamadı.');
    err.status = response.status;
    throw err;
  }

  return data;
}

export async function login(email, password) {
  return apiRequest('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  });
}

// Kimlik doğrulamalı dosya indirme: JWT ile korunan bir uç noktadan blob çeker ve tarayıcıda indirmeyi tetikler
export async function downloadBlob(path, fallbackName = 'download') {
  const user = getStoredUser();
  const response = await fetch(`${API_BASE_URL}${path}`, {
    headers: { ...(user?.token ? { Authorization: `Bearer ${user.token}` } : {}) },
  });

  if (response.status === 401 && user?.token) {
    clearStoredUser();
    window.dispatchEvent(new Event('auth:unauthorized'));
  }

  if (!response.ok) {
    const err = new Error('Dosya indirilemedi.');
    err.status = response.status;
    throw err;
  }

  const blob = await response.blob();
  // Content-Disposition başlığından dosya adını çıkar; yoksa fallback kullan
  const disposition = response.headers.get('Content-Disposition') || '';
  const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(disposition);
  const fileName = match ? decodeURIComponent(match[1]) : fallbackName;

  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  window.URL.revokeObjectURL(url);
}